// extracted by mini-css-extract-plugin
export default {"marquee":"Marquee_marquee__WpzQO","movespan":"Marquee_movespan__DnhkW"};